import { getOrder } from '@graphql/getOrder';
import { DefaultVariables, GraphQLRequestProps, request } from '@repo/ui/src/utils/graphql-request';
import { formatOrder } from '@hooks/order/helpers';
import { OrderData } from '@repo/ui/src/types/order';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import useSWRMutation from 'swr/mutation';

export interface SearchOrderVariables extends DefaultVariables {
  order: string;
  email: string;
}

const fetcher = async (
  props: GraphQLRequestProps,
  { arg: variables }: { arg: SearchOrderVariables },
) => {
  const data = await request<{ searchOrder: OrderData | null }>({
    ...props,
    variables,
  });
  return data?.searchOrder ? formatOrder(data.searchOrder) : undefined;
};
export const useGetOrder = () => {
  const { locale } = useCurrentUrl();

  return useSWRMutation({ locale, document: getOrder }, fetcher);
};
